import { render, staticRenderFns } from "./AnswerOptionsSelector.vue?vue&type=template&id=1d5cb8da&scoped=true&"
import script from "./AnswerOptionsSelector.vue?vue&type=script&lang=ts&"
export * from "./AnswerOptionsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerOptionsSelector.vue?vue&type=style&index=0&id=1d5cb8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5cb8da",
  null
  
)

export default component.exports